export default __webpack_public_path__ + "static/media/gold-bag-image.e1a8203d.png";